'use client';

import { useState } from 'react';
import PrivacyNoticeModal from './PrivacyNoticeModal';
import type { PrivacyNoticeAudience } from '@/content/legal';

interface PrivacyNoticeLinkProps {
  /**
   * Audience the modal opens with by default. Student version is the default
   * because the broader audience on the login page is pupils; teachers can
   * still flip with the in-modal toggle.
   */
  defaultAudience?: PrivacyNoticeAudience;
}

/**
 * Bottom-left "Privacy Notice" trigger that mirrors the TTRS pattern. Renders
 * an inline button (not a real anchor) so the modal opens in place without a
 * navigation. The modal carries both student + teacher variants behind a
 * toggle.
 */
export default function PrivacyNoticeLink({
  defaultAudience = 'student',
}: PrivacyNoticeLinkProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        className="fixed bottom-3 left-4 z-10 min-h-[44px] px-2 text-xs font-baloo-2 text-grayscale-500 underline-offset-2 hover:underline hover:text-brand-purple focus-visible:outline-2 focus-visible:outline-brand-purple focus-visible:outline-offset-2 rounded-md select-none"
      >
        Privacy Notice
      </button>
      <PrivacyNoticeModal
        open={open}
        onClose={() => setOpen(false)}
        initialAudience={defaultAudience}
      />
    </>
  );
}
